export const SEND_FLOW_PHASE = {
  IDLE: 'idle',
  LOADING: 'loading',
  STATISTICS: 'statistics',
  STARTED: 'started',
};

export type SendFlowPhase = (typeof SEND_FLOW_PHASE)[keyof typeof SEND_FLOW_PHASE];

export const SEND_MESSAGES_POLL_INTERVAL_MS = 5000;
export const MAX_NUMBER_ATTEMPTS = 6;
